import React, {Component} from 'react'
import PropTypes from "prop-types"

class GenerateResuls extends Component {
    render() {
        const {data} = this.props
        const {errorOrders, successOrders} = data

        return <div className="Results">
            {errorOrders.length > 0 && (
                <div className="Error mt-2">
                    <label>Errors:</label>
                    {errorOrders.map(item => {
                        return <div className="text-danger" key={item.id}><strong>#{item.barcodeNumber}_{item.itemNumber}</strong> {item.error}</div>
                    })}
                </div>
            )}
            {successOrders.length > 0 && (
                <div className="Success mt-2">
                    <label className="mb-0 d-block">Success:</label>
                    {successOrders.map(itemSucc => {
                        return <span className="text-success mr-2" key={itemSucc.id}><strong>#{itemSucc.barcodeNumber}_{itemSucc.itemNumber}</strong></span>
                    })}
                </div>
            )}
        </div>
    }
}

GenerateResuls.propTypes = {
    data: PropTypes.object.isRequired,
}

export default GenerateResuls